import axios from "axios";

import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getCommissions = async (params: any) => {
  const url = endpoints.COMMISSION;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params
  });

  return response;
};

const createCommission = async (params: any) => {
  const url = endpoints.COMMISSION;

  const { data: response } = await axios.post(url, params?.data, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const viewCommission = async (viewId: any) => {
  const url = endpoints.COMMISSION_DETAIL(viewId);

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const editCommission = async (params: any) => {
  const url = endpoints.COMMISSION_DETAIL(params?.data.id);

  const { data: response } = await axios.patch(url, params?.data, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteCommission = async (id: any) => {
  const url = endpoints.COMMISSION_DETAIL(id);

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const service = {
  getCommissions,
  createCommission,
  editCommission,
  viewCommission,
  deleteCommission
};

export default service;
